<template>
  <div class="home" v-loading="loading">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide slide-one">
        <!-- <Transition name="slide-fade">
          <div
            style="color: #000"
            v-if="transition"
            @click="
              (v) => (
                (this.transition = false),
                setTimeout(() => {
                  this.transition = true;
                }, 2000)
              )
            "
          >
            hello
          </div>
        </Transition> -->

        <!-- <div class="login-img">
          <img src="@/assets/img/layout/home_logo.png" alt="" />
        </div>
        <div class="page">
          <h3>广州市富尔菱自动化系统有限公司</h3>
        </div> -->
        <!-- <p class="slogan">{{ $t("home.slogan") }}</p> -->
      </swiper-slide>

      <swiper-slide class="swiper-slide slide-two">
        <div class="case-item">
          <div class="item-top">
            <div class="item-box item-top-left">
              <!-- <router-link
                class="text-decoration"
                :to="{ name: 'casedetails', params: { id: 37 } }"
              > -->
              <div class="box-img">
                <img src="@/assets/img/home_c2.png" alt="" />
              </div>
              <!-- </router-link> -->
              <div class="box-li" @click="(v) => handleGoPage(v, 'package')">
                <span clickItem="p" class="box-li-title text-solid-slide"
                  >智能包装数字化软件平台</span
                >
                <span clickItem="2" class="box-li-text box-li-left">MES系统</span>
                <span clickItem="3" class="box-li-text box-li-left">WMS系统</span>
                <span clickItem="4" class="box-li-text box-li-left">WCS系统</span>

                <span clickItem="5" class="box-li-text box-li-left">赋码追溯系统</span>
                <span clickItem="6" class="box-li-text box-li-left"
                  >机器人傻瓜操作系统</span
                >
                <!-- 数据采集、设备监控系统 -->
              </div>
            </div>
            <div class="item-box item-top-right">
              <div class="box-img">
                <img src="@/assets/img/home_a2.png" alt="" />
              </div>
              <div class="box-li" @click="handleGoToCaes">
                <span clickItem="f" class="box-li-title text-solid-slide">智能包装</span>
                <span clickItem="t" class="box-li-text box-li-left">柔性输送系统</span>
                <span clickItem="z" class="box-li-text box-li-left">智能包装</span>
                <span clickItem="c" class="box-li-text box-li-left">智能仓储</span>
                <span clickItem="e" class="box-li-text box-li-left">AGV、机器人应用</span>
              </div>
            </div>
          </div>
          <div class="item-bottom">
            <div class="item-box item-bottom-left">
              <div class="box-li" @click="handleGoProduct">
                <span class="box-li-title text-solid-slide" clickItem="conveyor">产品中心</span>
                <span clickItem="conveyor" class="box-li-text box-li-right">柔性物流输送系统</span>
                <span clickItem="packer" class="box-li-text box-li-right">自动装箱机</span>
                <span clickItem="palletizing" class="box-li-text box-li-right">机器人码垛系统</span>
                <span clickItem="warehouse" class="box-li-text box-li-right">智能仓储系统</span>
                <span clickItem="agv" class="box-li-text box-li-right">AGV机器人</span>
              </div>

              <div class="box-img">
                <img src="@/assets/img/home_b-2.png" alt="" />
              </div>
            </div>

            <!-- （1）高速柔性输送系统 （2）全自动装箱机 （3）机器人码垛系统 （4）智能仓储系统
            ①RGV仓储系统 ②轻型仓储 ③平库 （5）AGV ①特种机器人AGV ②潜伏式AGV ③叉车式AGV
            （6）复合机器人 （7）螺旋塔 （8）提升机 （9）标准柔性输送链 -->
            <!-- <div class="item-box item-bottom-left">
              <div class="box-li">
                <span class="box-li-title text-solid-slide">机器人应用</span>
                <span class="box-li-text box-li-right">机器人拆、码垛集成系统</span>
                <span class="box-li-text box-li-right">AGV机器人</span>
                <span class="box-li-text box-li-right">重载机器人AGV</span>
                <span class="box-li-text box-li-right">复合移动机器人</span>
              </div>

              <div class="box-img">
                <img src="@/assets/img/home_b-1.jpg" alt="" />
              </div>
            </div> -->
            <div class="item-box item-bottom-right">
              <div class="box-li">
                <span class="box-li-title text-solid-slide">实训中心</span>

                <span class="box-li-text box-li-right">机器人应用及维保</span>
                <span class="box-li-text box-li-right">工业数字化-智能包装</span>
                <span class="box-li-text box-li-right">3D仿真、数字双孪生</span>
                <!-- <span class="box-li-text box-li-right">追溯系统</span>
                <span class="box-li-text box-li-right">机器人应用</span> -->
              </div>

              <div class="box-img">
                <img src="@/assets/img/home_d.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>

      <!-- <swiper-slide class="swiper-slide slide-two">
        <div class="case-item">
          <div class="case-top case-li">
            <router-link
              class="text-decoration"
              :to="{ name: 'casedetails', params: { id: 37 } }"
            >
              <div class="case-top-img">
                <div class="case-title">智能包装数字化软件平台</div>
                <img src="@/assets/img/home_c.jpg" alt="" />
              </div>
            </router-link>
            <div class="case-top-content">
              <ul>
                <li>MES系统</li>
                <li>WMS系统</li>
                <li>WCS系统</li>
                <li>追溯系统</li>
                <li>机器人应用</li>
              </ul>
            </div>
          </div>
          <div class="case-bottom case-li">
            <div class="case-top-content">
              <ul twoUl>
                <li>医疗</li>
                <li>食品</li>
                <li>日化</li>
                <li>生活用品</li>
                <li>家电产业</li>
              </ul>
            </div>
            <router-link
              class="text-decoration"
              :to="{ name: 'case', params: { id: 42 } }"
            >
              <div class="case-top-img case-bottom-img">
                <img src="@/assets/img/home_b.jpg" alt="" />
                <div class="case-title">智能包装</div>
              </div>
            </router-link>
          </div>
        </div>
      </swiper-slide> -->

      <swiper-slide class="swiper-slide slide-four">
        <div class="page">
          <h3>合作伙伴</h3>
          <p>携手共进,合作双赢,精诚团结,共创未来</p>
        </div>
        <div class="partner-content">
          <ul class="partner-img">
            <li v-for="(partner, i) in buddyList" :key="i">
              <img v-lazy="partner.img" alt />
            </li>
          </ul>
        </div>
        <!-- 优化：将Footer组件移至最后一个轮播页的底部，仅在页面最后展示，避免遮挡其他页面的主内容 -->
        <SiteFooter />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
// 新增：引入单独封装的Footer组件
import SiteFooter from "@/components/SiteFooter.vue";

export default {
  name: "Home",
  components: {
    swiper,
    swiperSlide,
    // 新增：注册Footer组件
    SiteFooter,
  },
  data() {
    return {
      transition: false,
      loading: false,
      caseList: [],
      buddyList: [
        { name: 1, img: require("@/assets/img/ourParter/p1.png") },
        { name: 2, img: require("@/assets/img/ourParter/p2.png") },
        { name: 3, img: require("@/assets/img/ourParter/p3.png") },
        { name: 4, img: require("@/assets/img/ourParter/p4.png") },
        { name: 5, img: require("@/assets/img/ourParter/p5.png") },
        { name: 6, img: require("@/assets/img/ourParter/p6.png") },
        { name: 7, img: require("@/assets/img/ourParter/p7.png") },
        { name: 8, img: require("@/assets/img/ourParter/p8.png") },
        { name: 9, img: require("@/assets/img/ourParter/p9.png") },
        { name: 10, img: require("@/assets/img/ourParter/p10.png") },
        { name: 11, img: require("@/assets/img/ourParter/p11.png") },
        { name: 12, img: require("@/assets/img/ourParter/p12.png") },
        { name: 13, img: require("@/assets/img/ourParter/p13.png") },
        { name: 14, img: require("@/assets/img/ourParter/p14.png") },
        { name: 15, img: require("@/assets/img/ourParter/p15.png") },
        { name: 16, img: require("@/assets/img/ourParter/p16.png") },
        { name: 17, img: require("@/assets/img/ourParter/p17.png") },
        { name: 18, img: require("@/assets/img/ourParter/p18.png") },
        { name: 19, img: require("@/assets/img/ourParter/p19.png") },
        { name: 20, img: require("@/assets/img/ourParter/p20.png") },
        { name: 21, img: require("@/assets/img/ourParter/p21.png") },
        { name: 22, img: require("@/assets/img/ourParter/p22.png") },
        { name: 23, img: require("@/assets/img/ourParter/p23.png") },
        { name: 24, img: require("@/assets/img/ourParter/p24.png") },
      ],
      newsList: [{ img: require("@/assets/img/home_anli.jpg"), name: "" }],
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight - 60, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          // slideChange: () => {
          //   let swiper = this.$refs.mySwiper.swiper;
          //   //console.log(swiper.activeIndex); //滑动打印当前索引
          //   if (swiper.activeIndex === this.list.length - 1) {
          //     //到最后一个加载更多数据
          //     let newList = [];
          //     let listLength = this.list.length;
          //     for (let i = 0; i < 10; i++) {
          //       newList.push(listLength + i);
          //     }
          //     this.list = this.list.concat(newList);
          //   }
          // }
        },
      },
    };
  },
  created() {
    console.log("111111111111111111");
  },
  beforeMount() {
    setTimeout(() => {
      this.transition = true;
    }, 2000);
  },
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    // this.$http
    //   .all([this.$http.get("Cases/GetCasesAll"), this.$http.get(`News?type=1&num=3`)])
    //   .then(
    //     this.$http.spread((responseCases, responseNews) => {
    //       this.caseList = responseCases.data;
    //       this.newsList = responseNews.data;
    //       this.loading = false;
    //     })
    //   );
  },
  methods: {
    handleGoToCaes() {
      this.$router.push({ path: "case" });
    },
    /**
     * @param { type } 类型，
     * 智能包装： package 、
     * 智能数字化： digitize 、
     * 机器人应用： robot 、
     * 实训中心： center 、
     * @param { id } 跳转的id
     * */
    handleGoPage(e, type) {
      let id = e.target.attributes["clickitem"].value;
      console.log(type, id, "````````````````````");

      // this.$router.push({ name: "casedetails", params: { type, id: id } });
      this.$router.push({ path: "casedetails", query: { id, type } });
    },
    handleGoProduct(e) {
      const attr = e.target && e.target.attributes && e.target.attributes["clickitem"];
      if (!attr) return;
      const id = attr.value;
      this.$router.push({ path: "product2", query: { id } });
    },
  },
};
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(200px);
  opacity: 0;
}
</style>

<style lang="scss" scoped>
img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

ul {
  padding: 20px;
  li {
    cursor: pointer;
    // padding: 10px;
    box-sizing: border-box;
    margin: 10px 0;
    // border: 1px solid red;
    // background: rgba(29, 67, 255, 0.6);
    // background: rgba(43, 78, 255, 0.4);
    box-shadow: 0 0 6px 2px rgba(196, 192, 250, 0.6);
    transition: all 0.4s;
    &:hover {
      transform: scale(1.3);
    }
  }
}
// ul[twoUl] {
//   li {
//     @include row-c;
//     justify-content: flex-end;
//     // border: 1px solid skyblue;
//   }
// }

.swiper-slide {
  font-size: 24px;
  // text-align: center;
  // line-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  // 首页图标
  .login-img {
    width: 220px;
    height: 200px;
    margin: 0 auto;
    border-radius: 50%;
    background: rgba(223, 223, 223, 0.8);
    box-shadow: 0px 0px 4px 2px rgb(151, 151, 151);
    padding: 20px;
    box-sizing: border-box;
  }
  // 标题
  .page {
    text-align: center;
    height: 120px;
    overflow: hidden;
    h3,
    p {
      font-size: 50px;
      font-weight: 400;
      font-family: "阿里楷体";

      color: #008fd7;
      // color: $themeColor;
      text-shadow: 1px 1px 2px rgb(223, 182, 68);
      // text-shadow: 2px 2px 4px hsl(0, 0%, 22%);
      // color: hsl(189, 100%, 50%);
      // color: #ff4800;
    }
  }

  .slogan {
    text-align: center;
    font-size: 44px;
    color: #ffffff;
    // color: #006aff;
    padding: 20px 0;
  }
}
//经典案例
// .case-item {
//   width: 1100px;
//   height: 720px;
//   @include col-c;
//   row-gap: 30px;
//   margin: 0 auto;
//   .case-title {
//     color: #fff;
//     font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande", "Lucida Sans",
//       Arial, sans-serif;
//     font-weight: 400;
//     // mix-blend-mode: difference;
//     font-size: 28px;
//     @include cc;
//     z-index: 1;
//     font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
//   }
//   .case-li[class~="case-top"] {
//     justify-content: flex-start;
//   }
//   .case-li {
//     flex: 1;
//     height: 100%;
//     width: 100%;
//     @include row-c;
//     justify-content: flex-end;
//     color: #fff;
//     .case-top-img {
//       overflow: hidden;
//       width: 500px;
//       height: 280px;
//       position: relative;
//       img {
//         transition: all 0.5s;
//         &:hover {
//           transform: scale(1.2);
//         }
//       }
//     }
//     .case-top-content {
//       width: 350px;
//       height: 300px;
//     }
//   }
// }
// 经典案例1
.case-item {
  width: 1240px;
  min-height: 580px;
  margin: 0 auto;
  // border: 1px solid red;
  @include col-c;
  gap: 40px;
  .item-top,
  .item-bottom {
    width: 100%;
    height: 100%;
    @include row-c;
    gap: 50px;
    // border: 1px solid red;
  }
  .item-box {
    width: 100%;
    height: 100%;
    @include row-c;
    gap: 15px;
    // border: 1px solid rgb(190, 229, 73);
    box-shadow: 1px 1px 4px 2px $themeColor;
    border-radius: 10px;
    background: rgba($color: rgb(233, 233, 233), $alpha: 0.8);
    // background: rgba($color: skyblue, $alpha: 0.8);
    padding: 15px;
    box-sizing: border-box;
    .box-img {
      width: 100%;
      height: 100%;
      padding: 5px;
      box-sizing: border-box;
      @include row-c;
      img {
        // width: 200px;
        // height: 200px;
        width: 100%;
        height: 100%;
      }
    }
    .box-li {
      display: inline-block;
      width: 100%;
      height: 100%;
      @include col-c;

      // justify-content: flex-start;
      gap: 5px;
      color: #fff;
      // align-items: flex-start;
      // width: 100%;
      // border: 1px solid red;
      .box-li-title {
        // margin: 10px 0;
        margin-bottom: 10px;
        color: #000;
        // color: $themeColor;
        font-family: "阿里楷体";
        // color: $themeColor;
        font-size: 24px;

        // cursor: pointer;
        // background: linear-gradient(to right, red, green) no-repeat left bottom;
        // background-size: 0 2px;
        // transition: background-size 1000ms;
        // &:hover {
        //   background-size: 100% 2px;
        // }
        // text-shadow: 1px 1px 1px rgb(203, 203, 0);
      }
      .box-li-text {
        padding: 5px 10px;
        width: 100%;
        font-size: 20px;
        box-sizing: border-box;
        // color: #000;
        background: rgba(28, 28, 28, 0.336);
        color: #fff;
        transition: all 0.5s;
        cursor: pointer;
        &:hover {
          transform: scaleX(1.1);
        }
        // border: 1px solid red;
        &[class*="box-li-left"]::before {
          content: "";
          width: 15px;
          height: 15px;
          margin-right: 10px;
          position: relative;
          display: inline-block;
          background: #eba33f;

          // background: $themeColor;
          border-radius: 50%;
        }
      }
      .box-li-text[class*="box-li-right"] {
        @include row-c;
        justify-content: flex-end;
        &::after {
          content: "";
          width: 15px;
          height: 15px;
          margin-left: 10px;
          position: relative;
          display: inline-block;
          background: #eba33f;
          // background: $themeColor;
          border-radius: 50%;
        }
      }
    }
  }
}

.slide-one {
  background: url(../assets/img/jianjietopmin.jpg) no-repeat center;
  // background: url(../assets/img/home_top1.jpg) no-repeat center;
  background-size: cover;
}
.slide-two {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}
.slide-three {
  background: url(../assets/img/home_anli.jpg) no-repeat center;
  background-size: cover;
}
.slide-four {
  background: url(../assets/img/home_news.jpg) no-repeat center;
  background-size: cover;
  position: relative; /* 优化：确保绝对定位的Footer相对于最后一页定位 */
  padding-bottom: 60px; /* 优化：为底部的Footer留出空间，避免遮挡合作伙伴内容 */
  box-sizing: border-box;
  .page {
    h3,
    p {
      font-size: 50px;
      font-weight: 400;
      font-family: "阿里楷体";
    }
  }
}

//合作伙伴
.partner-content {
  width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;

  .partner-img {
    // width: 1250px;
    // height: 120px;
    // margin: 20px auto;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    // row-gap: 10px;
    column-gap: 34px;

    li {
      // padding: 10px;
      width: 120px;
      height: 117px;
      // list-style: none;
      // margin: 10px 23px;
      // box-sizing: border-box;
      // box-shadow: 0 1px 6px 4px rgb(150, 181, 201);
      img {
        width: 100%;
        height: 100%;
        // border: 1px solid rgb(194, 218, 235);
      }
    }
  }
}
.order {
  order: -1;
}
.order-img {
  order: 1;
}
</style>
